import { Outlet } from "react-router";
import Layout from "../../components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const ShowCase = ({ subRoutes }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !subRoutes.find((route) => route.isVisible) &&
      window.location.pathname === "/showcase"
    ) {
      navigate("/showcase/list");
    }
  }, []);

  return (
    <div className="h-screen min-h-full max-h-full dark:bg-gray-900 bg-gray-200 overflow-auto ">
      <Layout>
        <Outlet />
      </Layout>
    </div>
  );
};

export default ShowCase;
